import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectBffBaseUrl } from '../../store/selectors/api-config.selectors';
import { APIService } from './api.service';
import { map, switchMap } from 'rxjs/operators';
import { LocaleInfo } from '@shared/services/locale.service';

@Injectable({ providedIn: 'root' })
export class AccountApiService {
  private basePath: string;
  private basePath$: Observable<string>;

  constructor(
    private apiService: APIService,
    private store: Store,
  ) {
    this.basePath$ = this.store.pipe(
      selectBffBaseUrl,
      map((url) => `${url}/app/account`),
    );
    this.store.pipe(selectBffBaseUrl).subscribe((url) => {
      this.basePath = `${url}/app/account`;
    });
  }

  deleteMyAccount(): Observable<any> {
    return this.apiService.callDeleteAPI(`${this.basePath}/myaccount`);
  }

  getMyAccountTerminationStatus(): Observable<any> {
    return this.apiService.callGetAPI(
      `${this.basePath}/myaccount/accountTermination`,
    );
  }

  terminateMyAccount(): Observable<any> {
    return this.apiService.callPostAPI(
      `${this.basePath}/myaccount/accountTermination`,
      null,
    );
  }

  deleteMyAccountTermination(): Observable<any> {
    return this.apiService.callDeleteAPI(
      `${this.basePath}/myaccount/accountTermination`,
    );
  }

  getUserLocale$() {
    return this.basePath$.pipe(
      switchMap((basePath) =>
        this.apiService.callGetAPI<LocaleInfo>(`${basePath}/myaccount/locale`),
      ),
    );
  }

  setUserLocale$(locale: string) {
    return this.basePath$.pipe(
      switchMap((basePath) =>
        this.apiService.callPutAPI(`${basePath}/myaccount/locale`, { locale }),
      ),
    );
  }

  exportData(body: any): Observable<any> {
    return this.apiService.callPostAPI(
      `${this.basePath}/myaccount/data-export`,
      body,
    );
  }
}
